<template>
	<div class="head_wrap flex2">
		<div class="head_con flex1">
			<img class="hc_left" @click="goHome" src="@/images/logo.png" />
			<div class="hc_right flex3" v-show="headList.length">
                <div class="hr_item" v-if="sebox==false" v-for="(item, index) in headList" :key="item.title" @click="navClick(item)"
                    :class="headAct == index ? 'act_sty2' : ''" @mouseenter="moveIn(item.id)" @mouseleave="moveOut">
                    <span class="nv_tit tit_text">{{ item.title }}</span>
                    <ul v-show="mosAct == item.id">
                        <li v-for="(item2, index2) in item.son" :key="index2" @click.stop="toPageTwo(item, item2, index2)">
                            {{ item2.title }}
                        </li>
                    </ul>
                </div>
                <div class="hr_item2 flex2" v-if="sebox==false" @click="handleoA">
                    <img src="@/images/OA.png">
                    <span class="nv_tit">OA</span>
                </div>
				<div class="se_box flex2">
                    <div class="flex3 put_box" v-if="sebox==true">
                        <input type="text" placeholder="请输入关键词" v-model="keywords">
                        <span @click="toSearch">搜索</span>
                    </div>
					<img v-if="sebox==false" @click="sebox=true" src="@/images/zoom2.png">
					<img v-if="sebox==true" @click="sebox=false" src="@/images/close2.png">
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { mapState, mapActions } from "vuex";
export default {
	data() {
		return {
			staticImg: this.$staticImg,
			newsKey: '',
			mosAct: null,
            sebox:false,
            keywords:'',
            oaurl:'',
		};
	},
	computed: {
		...mapState(["headList", "headAct"]),
	},
	created() { 
        this.jconfig();
    },
	methods: {
		navClick(item) {
			this.$router.push(item.name);
		},
		handleSearch() {
			// console.log('搜索');
		},
		goHome() {
			this.$router.push('/');
		},
		toSearch() {
			this.$router.push('/search?keyword='+this.keywords);
		},
		moveIn(id) {
			this.mosAct = id;
		},
		moveOut() {
			this.mosAct = null;
		},
		toPageTwo(item, item2, index2) {
			if (item2.name) {
				this.$router.push(item2.name);
			} else {
				if (item.title == '关于集团') {
					this.$router.push('/aboutUs?sort=' + (index2 + 1));
				}
				if (item.title == '业务领域') {
					this.$router.push('/business?sort=' + (index2 + 1));
				}
			}
		},
        // 配置信息接口
		async jconfig() {
			const res = await this.$api.jconfig();
            // console.log(444,res)
            // blacktype 2是黑色，1正常
			if (res.code == 1) {
				this.oaurl = res.data.oaurl;
			}
		},
        handleoA(){
            if(this.oaurl){
                window.open(this.oaurl, '_blank');
            }
        }
	},
};
</script>
<style lang="scss">

.act_sty2 {
	.nv_tit {
		color: #003f99 !important;
		font-weight: bold;
	}
}

/* 定义展开/收起动画 */
.v-enter-active {
	transition: all 0.5s ease;
	max-height: 500px;
	opacity: 1;
}

.v-leave-active {
	max-height: 0;
	opacity: 0;
}

.head_wrap {
	position: fixed;
	left: 0;
	right: 0;
	top: 0;
	z-index: 3000;
	height: 90px;
	background-color: #fff;

	.head_con {
		width: 1440px;
		height: 90px;
		min-width: 1000px;
		cursor: pointer;

		.hc_left {
			width: 280px;
			height: auto;
		}

		.hc_right {
			margin-left: 65px;

			.hr_item {
				box-sizing: border-box;
				position: relative;

				.nv_tit {
					display: block;
					padding: 0 24px;
					color: #333;
					font-size: 17px;
					height: 90px;
					line-height: 90px;

					&:hover {
						color: #003f99 !important;
						font-weight: bold;
					}
				}

				ul {
					position: absolute;
					top: 90px;
					left: 0;
					right: 0;
					text-align: center;
					background-color: rgba(0, 0, 0, 0.25);
					box-sizing: border-box;

					li {
						color: #fff;
						padding: 15px 0;
						font-size: 16px;

						&:nth-child(1) {
							padding-top: 20px;
						}

						&:nth-last-child(1) {
							padding-bottom: 20px;
						}

						&:hover {
							color: #003f99;
						}
					}

					li:hover {
						color: #ceddfb;
						border-color: rgba(206, 221, 251, 0.3);
					}
				}
			}

			.hr_item2 {
				padding: 0 24px;

				img {
					width: 22px;
				}

				.nv_tit {
					display: block;
					color: #333;
					font-size: 17px;
					height: 90px;
					line-height: 90px;
					margin-left: 10px;

					&:hover {
						color: #003f99 !important;
						font-weight: bold;
					}
				}
			}

			.se_box {
				margin-left: 20px;
                .put_box{
                    margin-right: 20px;
                    border: 1px solid #ddd;
                    input{
                        width: 260px;
                        height: 38px;
                        border: none;
                        padding: 0 10px;
                        outline: none;
                    }
                    span{
                        display: inline-block;
                        width: 60px;
                        height: 36px;
                        line-height: 36px;
                        text-align: center;
                        background-color: #003f99;
                        color: #fff;
                    }
                }
				img {
					width: 20px;
					margin-top: 3px;
				}
			}
		}
	}

	@media screen and (max-width: 1600px) {
		.head_con {
			width: 1200px;

			.hc_left {
				width: 220px;
			}

			.hc_right {
				margin-left: 40px;

				.hr_item {
					.nv_tit {
						padding: 0 15px;
						font-size: 16px;
					}
				}

				.hr_item2 {
					padding: 0 15px;

					img {
						width: 20px;
					}

					.nv_tit {
						font-size: 17px;
						margin-left: 10px;
					}
				}

				.se_box {
					margin-left: 10px;
					width: 150px;
					height: 50px;
					border-radius: 60px;

					span {
						font-size: 16px;
					}

					img {
						width: 20px;
						margin-left: 20px;
					}
				}
			}
		}
	}

	@media screen and (max-width: 1400px) {
		.head_con {
			width: 1100px;

			.hc_left {
				width: 180px;
			}

			.hc_right {
				margin-left: 20px;

				.hr_item {
					.nv_tit {
						padding: 0 10px;
						font-size: 16px;
					}
				}

				.hr_item2 {
					padding: 0 10px;

					img {
						width: 20px;
					}

					.nv_tit {
						font-size: 16px;
						margin-left: 10px;
					}
				}

				.se_box {
					margin-left: 10px;
					width: 130px;
					height: 45px;
					border-radius: 60px;

					span {
						font-size: 16px;
					}

					img {
						width: 15px;
						margin-left: 15px;
					}
				}
			}
		}
	}

	@media screen and (max-width: 1300px) {
		.head_con {
			width: 1000px;
		}
	}
}
</style>